import { render, staticRenderFns } from "./_primary_navigation.vue?vue&type=template&id=277eff78"
import script from "./_primary_navigation.vue?vue&type=script&lang=js"
export * from "./_primary_navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports